@if (wallet !== null) {
  <div
    class="fiat-tile card-interactive {{ css }} focus-link"
    [tabindex]="0"
    [ngClass]="{ 'is-active': active }"
    (click)="onClick($event)"
    (keydown.enter)="onClick($event)">
    <div class="fiat-tile-top">
      @if (getTransactionCounter(wallet)) {
        <span class="fiat-tile-pending bp-navbar-badge">
          <strong>{{ wallet?.getPendingTransactionCount() }}</strong>
        </span>
      }
      <div class="fiat-tile-currency">
        <span class="fiat-tile-currency-icon">
          <img
            [src]="fiat?.getLogo()"
            class="fiat-icon-size"
            (error)="img.src = fiat?.getDefaultLogo()"
            alt="{{ 'logo_alt_text' | translate }}"
            #img />
        </span>
        <span class="fiat-tile-currency-text">{{ fiat?.getName() }} {{ "wallet" | translate }}</span>
      </div>
      <div class="fiat-tile-buttons">
        @if (options) {
          <a class="fiat-tile-button">
            <span class="bpi__icon-incoming" (click)="deposit(); $event?.stopPropagation()"></span>
          </a>
        }
      </div>
    </div>
    <div class="fiat-tile-amount">
      <div class="fiat-tile-amount-big">
        <strong>
          {{ wallet?.getBalance() | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] } }}
        </strong>
      </div>
      <div class="fiat-tile-amount-small">
        @if (!isDefaultFiat()) {
          <span>
            {{
            toDefaultFiat() | fiat_precision_symbol: { id: defaultFiat()?.getId(), currencies: [defaultFiat()] }
            }}
          </span>
        }
      </div>
    </div>
  </div>
}
